function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 173.929,
  cy: 133.929,
  r: 99.9295,
  fill: "#E8EAEC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M176.437 54.3741C172.573 54.3741 79.7561 54.3741 71.0477 54.3741C67.67 54.3741 64.9355 57.1086 64.9355 60.4821V229.096C64.9355 232.469 67.67 235.204 71.0477 235.204H176.437C179.815 235.204 182.55 232.469 182.55 229.096V60.4821C182.55 57.1086 179.815 54.3741 176.437 54.3741Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M83.9111 235.204H71.0477C67.67 235.204 64.9355 232.469 64.9355 229.096V60.4821C64.9355 57.1086 67.67 54.3741 71.0477 54.3741H83.9111C80.5334 54.3741 77.7989 57.1086 77.7989 60.4821V229.096C77.7989 232.471 80.5334 235.204 83.9111 235.204Z",
  fill: "#E8EAEC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M162.516 72.2846H84.9691C82.2927 72.2846 80.1211 74.4561 80.1211 77.1353V104.165C80.1211 106.844 82.2927 109.017 84.9691 109.017H162.516C165.192 109.017 167.364 106.844 167.364 104.165V77.1353C167.364 74.4561 165.192 72.2846 162.516 72.2846Z",
  fill: "#E8EAEC"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M162.516 126.596H84.9691C82.2927 126.596 80.1211 128.769 80.1211 131.448V158.476C80.1211 161.155 82.2927 163.328 84.9691 163.328H162.516C165.192 163.328 167.364 161.155 167.364 158.476V131.448C167.364 128.769 165.192 126.596 162.516 126.596Z",
  fill: "#E8EAEC"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M162.516 180.908H84.9691C82.2927 180.908 80.1211 183.08 80.1211 185.759V212.788C80.1211 215.468 82.2927 217.639 84.9691 217.639H162.516C165.192 217.639 167.364 215.468 167.364 212.788V185.759C167.364 183.08 165.192 180.908 162.516 180.908Z",
  fill: "#E8EAEC"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M96.8144 109.017H84.9691C82.2927 109.017 80.1211 106.844 80.1211 104.165V77.1353C80.1211 74.4561 82.2927 72.2846 84.9691 72.2846H96.8144C94.1394 72.2846 91.9665 74.4561 91.9665 77.1353V104.165C91.9665 106.844 94.1394 109.017 96.8144 109.017Z",
  fill: "#C7CDD3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M96.8144 163.328H84.9691C82.2927 163.328 80.1211 161.155 80.1211 158.476V131.448C80.1211 128.769 82.2927 126.596 84.9691 126.596H96.8144C94.1394 126.596 91.9665 128.769 91.9665 131.448V158.476C91.9665 161.155 94.1394 163.328 96.8144 163.328Z",
  fill: "#C7CDD3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M96.8144 217.639H84.9691C82.2927 217.639 80.1211 215.468 80.1211 212.788V185.759C80.1211 183.08 82.2927 180.908 84.9691 180.908H96.8144C94.1394 180.908 91.9665 183.08 91.9665 185.759V212.788C91.9665 215.468 94.1394 217.639 96.8144 217.639Z",
  fill: "#C7CDD3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9949 86.5228H154.454C155.976 86.5228 157.211 85.289 157.211 83.7662C157.211 82.2447 155.977 81.0095 154.454 81.0095H90.9949C89.4721 81.0095 88.2383 82.2447 88.2383 83.7662C88.2383 85.289 89.4721 86.5228 90.9949 86.5228Z",
  fill: "#C7CDD3"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9949 100.292H115.987C117.51 100.292 118.744 99.0583 118.744 97.5355C118.744 96.014 117.51 94.7789 115.987 94.7789H90.9949C89.4721 94.7789 88.2383 96.014 88.2383 97.5355C88.2383 99.0583 89.4721 100.292 90.9949 100.292Z",
  fill: "#C7CDD3"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M127.012 94.7789C125.49 94.7789 124.256 96.014 124.256 97.5355C124.256 99.0583 125.49 100.292 127.012 100.292H137.332C138.854 100.292 140.089 99.0583 140.089 97.5355C140.089 96.014 138.854 94.7789 137.332 94.7789H127.012Z",
  fill: "#C7CDD3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M154.454 135.148H90.9949C89.4721 135.148 88.2383 136.383 88.2383 137.904C88.2383 139.427 89.4721 140.661 90.9949 140.661H154.454C155.976 140.661 157.211 139.427 157.211 137.904C157.211 136.383 155.976 135.148 154.454 135.148Z",
  fill: "#C7CDD3"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9949 154.43H109.081C110.604 154.43 111.838 153.196 111.838 151.674C111.838 150.152 110.604 148.917 109.081 148.917H90.9949C89.4721 148.917 88.2383 150.152 88.2383 151.674C88.2383 153.196 89.4721 154.43 90.9949 154.43Z",
  fill: "#C7CDD3"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9949 194.799H136.415C137.938 194.799 139.172 193.565 139.172 192.042C139.172 190.521 137.938 189.286 136.415 189.286H90.9949C89.4721 189.286 88.2383 190.521 88.2383 192.042C88.2383 193.565 89.4721 194.799 90.9949 194.799Z",
  fill: "#C7CDD3"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M141 203.055H124.073C122.55 203.055 121.316 204.29 121.316 205.812C121.316 207.335 122.55 208.568 124.073 208.568H141C142.522 208.568 143.757 207.335 143.757 205.812C143.757 204.29 142.522 203.055 141 203.055Z",
  fill: "#C7CDD3"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M113.047 203.055H90.9949C89.4721 203.055 88.2383 204.29 88.2383 205.812C88.2383 207.335 89.4721 208.568 90.9949 208.568H113.047C114.569 208.568 115.803 207.335 115.803 205.812C115.803 204.29 114.569 203.055 113.047 203.055Z",
  fill: "#C7CDD3"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M235.337 205.326C235.337 228.342 216.679 247 193.663 247C170.646 247 151.988 228.342 151.988 205.326C151.988 182.311 170.646 163.653 193.663 163.653C216.679 163.653 235.337 182.311 235.337 205.326Z",
  fill: "#C7CDD3"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M223.633 205.326C223.633 221.879 210.214 235.297 193.662 235.297C177.11 235.297 163.691 221.879 163.691 205.326C163.691 188.774 177.11 175.356 193.662 175.356C210.214 175.356 223.633 188.774 223.633 205.326Z",
  fill: "#E8EAEC"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M193.663 187.973C191.787 187.973 190.266 186.453 190.266 184.576V180.439C190.266 178.563 191.787 177.041 193.663 177.041C195.538 177.041 197.06 178.563 197.06 180.439V184.576C197.06 186.453 195.538 187.973 193.663 187.973Z",
  fill: "#969FA8"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M193.663 233.612C191.787 233.612 190.266 232.09 190.266 230.214V226.077C190.266 224.199 191.787 222.679 193.663 222.679C195.538 222.679 197.06 224.199 197.06 226.077V230.214C197.06 232.09 195.538 233.612 193.663 233.612Z",
  fill: "#969FA8"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M218.55 208.723H214.413C212.537 208.723 211.016 207.203 211.016 205.326C211.016 203.45 212.537 201.93 214.413 201.93H218.55C220.428 201.93 221.948 203.45 221.948 205.326C221.948 207.203 220.428 208.723 218.55 208.723Z",
  fill: "#969FA8"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M201.151 208.723H193.663C191.787 208.723 190.266 207.203 190.266 205.326V198.445C190.266 196.568 191.787 195.048 193.663 195.048C195.538 195.048 197.06 196.57 197.06 198.445V201.93H201.15C203.027 201.93 204.547 203.45 204.547 205.326C204.547 207.203 203.027 208.723 201.151 208.723Z",
  fill: "#969FA8"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M172.912 208.723H168.774C166.897 208.723 165.377 207.203 165.377 205.326C165.377 203.45 166.897 201.93 168.774 201.93H172.912C174.787 201.93 176.309 203.45 176.309 205.326C176.309 207.203 174.787 208.723 172.912 208.723Z",
  fill: "#969FA8"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 199.218,
  cy: 61.7828,
  r: 3.70438,
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 199.218,
  cy: 61.7828,
  r: 3.70438,
  stroke: "#717A82"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 218.667,
  cy: 172.914,
  r: 3.70438,
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 218.667,
  cy: 172.914,
  r: 3.70438,
  stroke: "#717A82"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 191.81,
  cy: 138.649,
  r: 3.70438,
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 191.81,
  cy: 138.649,
  r: 3.70438,
  stroke: "#717A82"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 191.811,
  cy: 41.4088,
  r: 5.40876,
  stroke: "#969FA8",
  strokeWidth: 4
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 231.631,
  cy: 134.944,
  r: 5.40876,
  stroke: "#C7CDD3",
  strokeWidth: 4
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.4088,
  cy: 196.993,
  r: 5.40876,
  stroke: "#C7CDD3",
  strokeWidth: 4
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118.648 35.8522C117.881 35.8522 117.259 36.4741 117.259 37.2413V40.0196H114.481C113.714 40.0196 113.092 40.6415 113.092 41.4087C113.092 42.1759 113.714 42.7979 114.481 42.7979H117.259V45.5762C117.259 46.3434 117.881 46.9653 118.648 46.9653C119.416 46.9653 120.038 46.3434 120.038 45.5762V42.7979H122.816C123.583 42.7979 124.205 42.1759 124.205 41.4087C124.205 40.6415 123.583 40.0196 122.816 40.0196H120.038V37.2413C120.038 36.4741 119.416 35.8522 118.648 35.8522Z",
  fill: "#717A82"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M260.342 176.619C259.575 176.619 258.953 177.241 258.953 178.008V180.786H256.174C255.407 180.786 254.785 181.408 254.785 182.175C254.785 182.942 255.407 183.564 256.174 183.564H258.953V186.343C258.953 187.11 259.575 187.732 260.342 187.732C261.109 187.732 261.731 187.11 261.731 186.343V183.564H264.509C265.276 183.564 265.898 182.942 265.898 182.175C265.898 181.408 265.276 180.786 264.509 180.786H261.731V178.008C261.731 177.241 261.109 176.619 260.342 176.619Z",
  fill: "#969FA8"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.8573 161.801C40.0901 161.801 39.4682 162.423 39.4682 163.19V165.968H36.6899C35.9227 165.968 35.3008 166.59 35.3008 167.358C35.3008 168.125 35.9227 168.747 36.6899 168.747H39.4682V171.525C39.4682 172.292 40.0901 172.914 40.8573 172.914C41.6245 172.914 42.2465 172.292 42.2465 171.525V168.747H45.0248C45.792 168.747 46.4139 168.125 46.4139 167.358C46.4139 166.59 45.792 165.968 45.0248 165.968H42.2465V163.19C42.2465 162.423 41.6245 161.801 40.8573 161.801Z",
  fill: "#969FA8"
});

var SvgInvoicesOpenEmpty = function SvgInvoicesOpenEmpty(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInvoicesOpenEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/invoicesOpenEmpty.7f411390.svg";
export { ForwardRef as ReactComponent };